import React from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from '../../../assets/images/arrow-icon.svg';

const SimpleLinkRenderer = ({
  value,
  onClick,
  data,
  showOpenInNewTab,
  onNewTabClick,
}) => (
  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <a style={{ color: '#3949ab' }} onClick={() => onClick(value, data)}>
      {value}
    </a>
    {showOpenInNewTab && (
      <img
        src={ArrowIcon}
        style={{ cursor: 'pointer', width: 12 }}
        onClick={() => onNewTabClick(value, data)}
      />
    )}
  </div>
);

SimpleLinkRenderer.propTypes = {
  data: PropTypes.any,
  showOpenInNewTab: PropTypes.boolean,
  value: PropTypes.any,
  onClick: PropTypes.func,
  onNewTabClick: PropTypes.func,
};

export default SimpleLinkRenderer;
